import * as i0 from "@angular/core";
export class RulebookLevelInterceptorService {
    constructor() { }
    intercept(request, next) {
        // First clear cache for make work at the moment
        Object.keys(localStorage).filter(value => value.includes('RB-ARTICLE')).forEach(value => {
            if (value.includes('Levels=-1') == false) {
                localStorage.removeItem(value);
            }
        });
        if (request.url.includes('RB-ARTICLE')) {
            let req = request.clone({ setParams: { 'Levels': "-1" } });
            if (req.params.get('LangID') == "undefined") {
                req = req.clone({ setParams: { 'LangID': undefined } });
            }
            return next.handle(req);
        }
        return next.handle(request);
    }
}
RulebookLevelInterceptorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RulebookLevelInterceptorService_Factory() { return new RulebookLevelInterceptorService(); }, token: RulebookLevelInterceptorService, providedIn: "root" });
